<template>
  <div>
    <el-container style="margin: 10px;">
      <el-header :height="'auto'" style="background: #fff; border-radius: 4px;">
        <el-form :inline="true" size="mini">
          <span class="form-date-picker">
            <el-form-item label="日期:">
              <el-date-picker
                style="width: 150px"
                v-model="tjTime1"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="至" class="date-picker-middle">
              <el-date-picker
                style="width: 150px"
                v-model="tjTime2"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </span>
          <el-form-item style="float: right; margin-top: -1px;">
            <button class="ioc-button i-mini i-success" @click="query">搜索</button>
          </el-form-item>
        </el-form>
      </el-header>
      <el-main style="padding: 10px;background: #fff; margin-top: 10px; border-radius: 4px;">
        <div style="margin-bottom: 10px;">
          <el-button type="primary" size="normal" @click="importDialog = true">导入</el-button>
        </div>
        <el-table
          :header-cell-style="{backgroundColor: '#F4F8FB'}"
          :data="tableData"
          border
          stripe
          :height="tableHeight"
          style="width: 100%">
          <el-table-column prop="fileNameShow" label="文件名" align="center"></el-table-column>
          <el-table-column prop="importUser" label="导入用户" align="center"></el-table-column>
          <el-table-column prop="creationDate" label="导入时间" align="center"></el-table-column>
          <el-table-column prop="processStatusDescription" label="解析状态" align="center"></el-table-column>
          <el-table-column prop="processResultDescription" width="120" label="解析结果" align="center"></el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template class="wrap" slot-scope="scope">
              <div class="wrap">
                <i class="iconfont down" @click="downloadFile(scope.row.fileInfo.fileName, scope.row.fileDataId)">&#xe680;</i>
                <i class="iconfont d"
                   @click="gotoEx(scope.row.dataId)"
                   v-if="scope.row.processResult === 'failPart' || scope.row.processResult === 'fail'">&#xe639;</i>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
              background
              :total="pageTotal"
              :current-page="page"
              :page-sizes="[30, 100, 500, 1000]"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </div>
      </el-main>
    </el-container>

    <!--导入弹出框-->
    <el-dialog title="导入数据" :visible.sync="importDialog" width="30%">
      <div class="up">
        <el-form :label-position="labelPosition" label-width="80px">
          <el-form-item label="数据导入">
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :auto-upload="false"
              :limit="1"
              :on-remove="handleRemove"
              :http-request="uploadFile"
              list-type="picture"
              ref="upload"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importDialog = false">取 消</el-button>
        <el-button type="primary" :loading="btnStatus" @click="subPicForm">确 定</el-button>
      </span>
    </el-dialog>
    <!--日志弹框-->
    <el-dialog title="异常日志" :visible.sync="exceptionLogDialog" width="55%">
      <exception-log :id="exceptionId"></exception-log>
    </el-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  // import {upData, getData1, downloadFile} from '@/api/data'
  import exceptionLog from './analysisExceptions'
  import FileSaver from 'file-saver'
  import HttpRequest from '../../../utils/axios';
  import {baseUrl} from '../../../utils/constant';
  import {Notification} from 'element-ui';
  import pagePathMixin from '@/utils/page-path-mixin'

  let currentMonthFirst = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  let currentMonthLast = new Date();
  export default {
    name: 'newProductAddTime2Remark',
    mixins: [pagePathMixin],
    components: {exceptionLog},
    data() {
      return {
        importDialog: false,
        exceptionId: null,
        exceptionLogDialog: false,
        tjTime1: '',
        tjTime2: '',
        tableData: [],
        taskType: 'newProductTime2RemarkGroup',
        // 分页
        page: 1,
        pageSize: 30,
        pageTotal: null,
        labelPosition: 'right',
        formData: '',
        btnStatus: false,
        tableHeight: null
      }
    },
    inject: ['reload'],
    methods: {
      // 上传
      uploadFile(file) {
        this.formData.append('file', file.file)
      },
      handleRemove(file, fileList) {
        console.log(file, fileList)
      },
      subPicForm() {
        this.formData = new FormData()
        this.$refs.upload.submit()
        this.formData.append('importType', this.taskType)
        this.btnStatus = true
        this.$q.newProduct.upData({data: this.formData}).then(res => {
          if (res.resultStatusEnum === 'failed') {
            this.$message.error(res.message);
            this.importDialog = true
            this.btnStatus = false
            this.load()
          } else {
            this.importDialog = false
            this.btnStatus = false
            this.query()
            this.$message.success(res.message);
          }
          this.$refs.upload.clearFiles()
        }).catch(err => {
          console.log(err.message)
        })
      },
      // 搜索
      query() {
        this.page = 1
        this.getData()
      },
      downTemplate() {
        FileSaver.saveAs('//imagecs.quanyou.com.cn/group1/M00/0A/2D/rB4DMF2xREOAYXI0AAAnOnV2LCQ83.xlsx')
      },
      // 翻页
      handleCurrentChange(val) {
        this.page = val
        this.getData()
      },
      handleSizeChange(val) {
        this.page = 1;
        this.pageSize = val;
        this.getData()
      },

      // 获取列表
      getData() {
        this.$q.newProduct.getData1(
          {
            params: {
              importType: this.taskType,
              pageNum: this.page,
              pageSize: this.pageSize,
              date: moment(this.tjTime1).format('YYYY-MM-DD'),
              endTime: moment(this.tjTime2).format('YYYY-MM-DD'),
              entrance: 'cds'
            }
          }
        ).then(res => {
          this.tableData = res.data.dataList
          this.pageTotal = res.data.total
        }).catch(err => {
          console.log(err.message)
        })
      },
      // 下载文件
      downloadFile(filename, id) {
        const apiName = process.env.BUILD_ENV === 'dev' ? '' : ''
        new HttpRequest(baseUrl).request({
          method: 'get',
          url: `${baseUrl}${apiName}ec-new-product-file-api/file/download?fileId=` + id,
          responseType: 'blob'
        }).then(res => {
          if (+res.status === 200) {
            let data = res.data;
            let fileReader = new FileReader();
            fileReader.onload = function () {
              try {
                let jsonData = JSON.parse(this.result);
                if (jsonData.code) {
                  // alert(jsonData.message)
                  Notification.error({
                    message: jsonData.message
                  })
                }
              } catch (e) {
                let fileName = filename;
                let blob = new Blob([res.data]);
                let url = window.URL.createObjectURL(blob);
                let link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.setAttribute('download', decodeURI(fileName));
                document.body.appendChild(link);
                link.click()
              }
            };
            fileReader.readAsText(data)
          } else {
            Notification.error({
              message: res.message
            })
          }
        })
      },
      // 获取异常
      gotoEx(id) {
        this.exceptionLogDialog = true
        this.exceptionId = id
      }
    },
    mounted() {
      this.tableHeight = window.innerHeight - 265
      this.getData()
    }
  }
</script>

<style lang="stylus" scoped>
  >>> .el-header
    padding 10px
  >>> .el-form-item
    margin-bottom 0px !important
  .pagination
    margin-top 10px
    text-align right
  .title
    color #666
    margin-bottom 10px
  .time-select
    margin 10px 0
  .data-wrapper
    margin 20px

    .top
      overflow hidden
      margin-top 20px

      .time-select
        float left

        .demonstration
          padding-right 15px

      .fun-tools
        float right
        margin-right 20px

    .data-table
      padding-top 10px

    .wrap
      overflow hidden
      width 76px
      margin 0 auto

      .ex-left
        float left

      .ex-right
        float right
  .d
    font-size 26px
    color #d20707
    cursor pointer
  .down,.d
    vertical-align middle
</style>
